import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { Checkbox } from '../../../Checkbox/Checkbox.js';
import { useRowSelect as useRowSelect$1 } from 'react-table';

var _excluded = ["onChange"],
    _excluded2 = ["onChange"];

var toggleBetween = function toggleBetween(fromRowIndex, toRowIndex) {
  var fromIndex = toRowIndex < fromRowIndex ? toRowIndex : fromRowIndex;
  var toIndex = toRowIndex > fromRowIndex ? toRowIndex : fromRowIndex;
  return [fromIndex, toIndex];
}; // react-table calls "index paths" row ids. we named them indexPaths to reduce confusion with natural ids
// the selection hook usess react-table's row selection, so this hok references row.id - it is the index path


var useRowSelect = function useRowSelect(onSelectedRows) {
  var plugin = function plugin(hooks) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useRowSelect$1(hooks);

    if (onSelectedRows) {
      var toggleRowSelected = function toggleRowSelected(indexPath, checked) {
        return onSelectedRows(function (state) {
          var nextState = _extends({}, state);

          if (checked) {
            nextState[indexPath] = true;
          } else {
            delete nextState[indexPath];
          }

          return nextState;
        });
      };

      var prepareRow = function prepareRow(row) {
        row.toggleRowSelected = function () {
          return toggleRowSelected(row.id, !row.isSelected);
        };
      };

      hooks.prepareRow.push(prepareRow); // eslint-disable-next-line react-hooks/rules-of-hooks

      var lastSelectedSortedIndex = React__default.useRef();
      hooks.visibleColumns.push(function (columns) {
        return [{
          id: 'selection',
          Header: function Header(_ref) {
            var getToggleAllRowsSelectedProps = _ref.getToggleAllRowsSelectedProps,
                rows = _ref.rows;

            var _getToggleAllRowsSele = getToggleAllRowsSelectedProps(),
                props = _objectWithoutPropertiesLoose(_getToggleAllRowsSele, _excluded);

            var onChange = function onChange(event) {
              if (event.target.checked) {
                // this intentionally only selects top level rows - sub rows add too much complexity
                onSelectedRows(Object.assign({}, Array(rows.length).fill(true)));
              } else {
                onSelectedRows({});
              }
            };

            return React__default.createElement(Checkbox, Object.assign({}, props, {
              onChange: onChange,
              className: "h-auto mt-px"
            }));
          },
          Cell: function Cell(_ref2) {
            var row = _ref2.row,
                rows = _ref2.rows;

            var _row$getToggleRowSele = row.getToggleRowSelectedProps(),
                props = _objectWithoutPropertiesLoose(_row$getToggleRowSele, _excluded2); // row.index refers to the index in the original data, not the current index


            var sortedIndex = rows.findIndex(function (r) {
              return r.index === row.index;
            });

            var onClick = function onClick(event) {
              if (event.shiftKey) {
                var _toggleBetween = toggleBetween(lastSelectedSortedIndex.current || 0, sortedIndex),
                    fromIndex = _toggleBetween[0],
                    toIndex = _toggleBetween[1];

                for (var i = fromIndex; i <= toIndex; i++) {
                  toggleRowSelected(rows[i].id, true);
                }
              } else {
                toggleRowSelected(row.id, !props.checked);
              }

              lastSelectedSortedIndex.current = sortedIndex;
            };

            return React__default.createElement(Checkbox, Object.assign({}, props, {
              className: "h-auto mt-px",
              onClick: onClick,
              // this is necessary to remove console spam from eslint
              onChange: function onChange() {
                return false;
              }
            }));
          },
          flex: '0 0 36px',
          className: 'flex-col justify-start'
        }].concat(columns);
      });
    }
  };

  plugin.pluginName = 'useRowSelect';
  return plugin;
};

export { useRowSelect };
//# sourceMappingURL=useRowSelect.js.map
